module.exports = __webpack_public_path__ + "images/descending-88979962.svg";